export default __webpack_public_path__ + "static/media/discussion2page1.d546c8ea.jpg";